<template>
  <div>
    <span>Deseja desarquivar o projeto: </span>
    <strong> {{ `${item.project_code} - ${item.project_name}` }}</strong>
    <br />
    <div
      :style="{
        paddingTop: '30px',
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        justifyContent: 'center',
      }"
    >
      <b-button variant="primary" @click="unArquiveProject"
        >Desarquivar</b-button
      >
      <b-button variant="outline-secondary" @click="closeUnDeleteModal"
        >Cancelar</b-button
      >
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
  components: {
    BButton,
  },
  props: {
    item: { type: Object, default: () => {} },
  },

  data() {
    return {
      showModal: false,
    };
  },

  methods: {
    async unArquiveProject() {
      this.$store
        .dispatch('unArquiveProject', {
          id: this.item.id,
        })
        .then((resp) => {
          if (resp) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Projeto desarquivado com sucesso',
                icon: 'SuccessIcon',
                variant: 'success',
              },
            });
          }
          this.closeUnDeleteModal();
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao arquivar projeto',
              icon: 'ErrorIcon',
              variant: 'success',
            },
          });
          console.log(err);
        });
    },

    closeUnDeleteModal() {
      this.$emit('closeUnDeleteModal');
    },
  },
};
</script>
